<template>
  <div class="icon" v-html="svgContent" />
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: 'black'
  }
})

const svgContent = ref('')

const loadSvg = async (iconName) => {
  try {
    const response = await fetch(`/assets/icons/${iconName}.svg`)
    if (!response.ok) throw new Error('Fetch failed')
    let svg = await response.text()

    if (props.color) {
      svg = svg.replace(/fill="[^"]*"/gi, '')
      svg = svg.replace(
        /<svg([^>]+)>/,
        `<svg$1 fill="${props.color}">`
      )
    }

    svgContent.value = svg
  } catch (error) {
    console.warn(`Could not load SVG "${iconName}":`, error)
    svgContent.value = ''
  }
}

watch(() => props.name, (newName) => {
  loadSvg(newName)
}, { immediate: true })

watch(() => props.color, () => {
  loadSvg(props.name)
})
</script>

<style scoped>
.icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
